// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","851":"component---src-templates-post-js"}[chunkId] + "-" + {"678":"d246d2cd0992c049d36d","851":"6e6e351d53d4fca10d52"}[chunkId] + ".js";
};